import angular from 'angular';

class chooseContainerModalCtrl {
  /* @ngInject */
  constructor(CompanyService, ContainerService) {
    this.CompanyService = CompanyService;
    this.ContainerService = ContainerService;
  }

  $onInit() {
    this.criteria = { motif: null };
  }

  onPrincipalChanged() {
    this.companies = this.CompanyService.searchByCriterias({ principalId: this.criteria.principal });
  }

  onCompanyChanged() {
    this.containers = this.ContainerService.searchByCriterias({
      companyId: this.criteria.company,
      containerStatus: 'ENABLE',
      containerType: 'MAIL'
    });
  }

  ok() {
    if (this.form.$valid) {
      this.modalInstance.close({ containerId: this.criteria.container, motif: this.criteria.motif });
    }
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }
}

angular.module('evl-waiting').component('chooseContainerModal', {
  templateUrl: require('./choose-container.html'),
  controller: chooseContainerModalCtrl,
  bindings: {
    resolve: '<',
    modalInstance: '<'
  }
});
